import {GoogleEventEnum, LandingEnum} from "_business";
import {sha256} from "js-sha256";
import Cookies from "js-cookie";
import mixpanel from 'mixpanel-browser';
import {getItem} from "./lib";
import {setupBingPixel, setupQuoraPixel, setupRedditPixel} from "utils";

const surveyCount = window.landing === LandingEnum.charisma ? 33 : 35

export function setStep(data, toAdd = true, force = false) {
  // console.log('setStep', data, toAdd, force)

  // if (window.previousData)
  //   setTrack('time_on_page', {
  //     ...window.previousData.data,
  //     seconds: Math.round((Date.now() - window.previousData.startTime) / 1000)
  //   }, window.previousData.toAdd)

  if (toAdd) {
    const resultList = getItem('survey_results')
    data.step += resultList.length - 1
  }

  if (
    force ||
    data.step > surveyCount && window.sessionStorage.getItem('summarize')
  )
    data.step++

  // console.log(data)
  setProfile({completed_steps: data.step})
  // mixpanel.track_pageview(data)

  // window.previousData = {
  //   data,
  //   toAdd,
  //   startTime: Date.now()
  // }
}

export function setTrackStep(action, data, toAdd = true, force = false) {
  // console.log('setTrackStep', action, data, toAdd, force)

  if (toAdd) {
    const resultList = getItem('survey_results')
    data.step += resultList.length - 1
  }

  if (
    force ||
    data.step > surveyCount && window.sessionStorage.getItem('summarize')
  )
    data.step++

  setTrack(action, data)
}

function tagLog(method, action, color, data) {
  if (!process.env.REACT_APP_DEBUG)
    return

  console.log(
    `%c${method}%c %s`,
    `background: ${color}; color: white; padding: 2px 6px; border-radius: 3px;`,
    `color: ${color}; font-weight: bold;`,
    action,
    data || ''
  )
}

export function setTrack(action, data) {
  tagLog('track', action, '#03b103', data)
  mixpanel.track(action, data)
}

export function setRegister(data) {
  tagLog('mixpanel', 'register', '#5533FF', data)
  mixpanel.register(data)
}

export function setProfile(data) {
  tagLog('mixpanel', 'profile', '#5533FF', data)
  mixpanel.people.set(data)
}


function gtagEvent(eIndex, params) {
  if (window.gtagConfig?.[eIndex])
    window.gtag(
      'event',
      'conversion', {
        'send_to': `${window.gtagConfig[0]}/${window.gtagConfig[eIndex]}`,
        ...{
          ...params,
          'transaction_id': window.session_uid,
        }
      }
    )
  else
    console.error('gtagConfig implementation');

  if (window.gtagConfigOur?.[eIndex])
    window.gtag(
      'event',
      'conversion', {
        'send_to': `${window.gtagConfigOur[0]}/${window.gtagConfigOur[eIndex]}`,
        ...{
          ...params,
          'transaction_id': window.session_uid,
        }
      }
    )
  else
    console.error('gtagConfigOur implementation');
}


export function identify(uid, email, data) {
  tagLog('mixpanel', 'identify', '#7c7c05', uid)
  mixpanel.identify(uid)

  mixpanel.people.unset([
    'initial_utm_source_platform',
    'initial_utm_marketing_tactic',
    'initial_utm_creative_format',
    'initial_utm_campaign_id',
  ])

  window._uid = uid
  window.localStorage.setItem('uid', uid)
  window.localStorage.setItem('identify', '1')

  if (email) {
    window._email = email
    setProfile({
      untracked: false,
      email,
      quiz: window.quiz,
      landing: window.landing,
      // country_code: window.sessionStorage.getItem('country_code'),
      ...data
    })
    window.localStorage.setItem('email', email)
    trackSignup(email)

    // set untracked=true in profile
    fetch(
      `${process.env.REACT_APP_API_URI}mp/${uid}`,
      {
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        // },
        body: JSON.stringify({})
      }
    )
      .then(() => {})
  }
}


export function trackContent(id) {
  if (window.ttq) {
    window.ttq.track('ViewContent', {
      contents: [
        {
          content_id: id // string. ID of the product. Example: "1077218".
        }
      ]
    }, {
      event_id: sha256('ViewContent_' + window.session_uid)
    })
  }

  // if (window.rdt)
  //   window.rdt('track', 'ViewContent', {
  //     reddit_click_id: window.localStorage.getItem('rdclid'),
  //     conversionId: sha256('ViewContent_' + window.session_uid),
  //     content_id: id,
  //   })

  fetch(
    process.env.REACT_APP_API_URI + 'web-sessions/view',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        session_uid: window.session_uid,
        ttclid: Cookies.get('ttclid'),
        ttp: Cookies.get('_ttp'),
        url: window.location.pathname + window.location.hash,
        content_id: id,
        rdclid: window.localStorage.getItem('rdclid'),
        qclid: window.localStorage.getItem('qclid'),
        msclkid: window.localStorage.getItem('msclkid'),
      })
    }
  )
    .then(() => {
    })
}

export function trackSignup(email) {
  if (window.gtag)
    window.gtag('event', 'sign_up', {method: 'email'})

  gtagEvent(GoogleEventEnum.register)

  if (window.ttq) {
    window.ttq.identify({
      email: window.localStorage.getItem('email') || '',
      sha256_email: sha256(email), // string. The email of the customer if available. It must be hashed with SHA-256 on the client side.
      sha256_phone_number: '',
      // phone_number: "<hashed_phone_number>", // string. The phone number of the customer if available. It must be hashed with SHA-256 on the client side.
      // external_id: sha256(Cookies.get('ttclid') || window.localStorage.getItem('ttclid') || window.session_uid), // string. A unique ID from the advertiser such as user or external cookie IDs. It must be hashed with SHA256 on the client side.
      external_id: sha256(window.session_uid),
    })

    // ttq.track('CompleteRegistration', {
    //   "contents": [
    //     {
    //       "content_id": "email" // string. ID of the product. Example: "1077218".
    //     }
    //   ]
    // }, {
    //   event_id: sha256('CompleteRegistration_' + window.session_uid)
    // });

    window.ttq.track('AddToCart', {
      contents: [
        {
          content_id: 'subscription' // string. ID of the product. Example: "1077218".
        }
      ]
    }, {
      event_id: sha256('AddToCart_' + window.session_uid)
    })
  }

  setupRedditPixel().then(() => {})
  setupQuoraPixel('track', 'AddToCart')
  // setupBingPixel('event', 'add_to_cart')
  setupBingPixel('event', 'sign_up')

  // if (window.rdt) {
    // window.rdt('init', 'a2_gzjiyabjbf36', {
    //   email: md5(email.trim().toLowerCase()),
    //   // phoneNumber: '<PHONE-NUMBER-HERE>',
    //   // externalId: window.localStorage.getItem('uid'),
    //   externalId: sha256(window.session_uid),
    //   // idfa: '<IDFA-HERE>',
    //   // aaid: '<AAID-HERE>',
    // })
  // }
}

export function trackPaywall() {
  if (window.gtag)
    window.gtag('event', 'view_item')

  gtagEvent(GoogleEventEnum.paywall)

  // if (window.ttq) {
  //   window.ttq.track('AddToCart', {
  //     "contents": [
  //       {
  //         "content_id": "subscription" // string. ID of the product. Example: "1077218".
  //       }
  //     ]
  //   }, {
  //     event_id: sha256('AddToCart_' + window.session_uid)
  //   });
  // }

  if (window.pintrk) {
    window.pintrk('track', 'signup', {
      event_id: sha256('Signup_' + window.session_uid),
    })
  }

  setupBingPixel('event', 'begin_checkout')
}

export function trackCheckout({fullPrice, currency, id, name}) {
  setTrack('start checkout')

  if (window.gtag)
    window.gtag('event', 'begin_checkout', {
      value: +fullPrice,
      currency,
      items: [
        {
          item_id: id,
          item_name: name,
        }
      ]
    })

  gtagEvent(GoogleEventEnum.checkout)

  if (window.ttq)
    window.ttq.track('InitiateCheckout', {
      value: fullPrice, // number. Value of the order or items sold. Example: 100.
      currency, // string. The 4217 currency code. Example: "USD".
      contents: [
        {
          content_id: id, // string. ID of the product. Example: "1077218".
          content_name: name // string. The name of the page or product. Example: "shirt".
        }
      ]
    }, {
      event_id: sha256('InitiateCheckout_' + window.session_uid)
    })

  if (window.pintrk)
    window.pintrk('track', 'addtocart', {
      event_id: sha256('InitiateCheckout_' + window.session_uid),
      value: fullPrice,
      order_quantity: 1,
      currency,
      order_id: window.session_uid,
      // promo_code: 'WINTER10',
      // property: 'Athleta',
      // search_query: 'boots',
      // video_title: 'How to style your Parker Boots',
      // lead_type: 'Newsletter',
      line_items: [
        {
          product_name: name,
          product_id: id,
          // product_category: 'Shoes',
          // product_variant_id: '1414-Red',
          // product_variant: 'Red',
          product_price: fullPrice,
          product_quantity: 1,
          // product_brand: 'Parker'
        }
      ]
    })

  setupRedditPixel('track', 'AddToCart', {
    content_id: id,
    content_name: name,
    value: +fullPrice,
    currency,
  }).then(() => {})

  setupQuoraPixel('track', 'InitiateCheckout', {
    content_id: id,
    content_name: name,
    value: +fullPrice,
    currency,
  })

  // setupBingPixel('event', 'begin_checkout', {
  //   revenue_value: +fullPrice,
  //   // content_id: id,
  //   // event_category: 'ecommerce',
  //   // event_label: name,
  //   currency,
  // })
}

export function trackPurchase({fullPrice, currency, id, name}) {
  setTrack('payment successful')
  window.localStorage.setItem('success', '1')

  if (window.gtag)
    window.gtag('event', 'purchase', {
      value: +fullPrice,
      currency,
      items: [
        {
          item_id: id,
          item_name: name,
        }
      ]
    })

  gtagEvent(GoogleEventEnum.purchase, {value: fullPrice, currency})

  if (window.ttq)
    window.ttq.track('CompletePayment', {
      value: fullPrice, // number. Value of the order or items sold. Example: 100.
      currency, // string. The 4217 currency code. Example: "USD".
      contents: [
        {
          content_id: id, // string. ID of the product. Example: "1077218".
          content_name: name // string. The name of the page or product. Example: "shirt".
        }
      ]
    }, {
      event_id: sha256('CompletePayment_' + window.session_uid)
    })

  if (window.pintrk)
    window.pintrk('track', 'checkout', {
      event_id: sha256('CompletePayment_' + window.session_uid),
      value: fullPrice,
      order_quantity: 1,
      currency,
      order_id: window.session_uid,
      // promo_code: 'WINTER10',
      // property: 'Athleta',
      // search_query: 'boots',
      // video_title: 'How to style your Parker Boots',
      // lead_type: 'Newsletter',
      line_items: [
        {
          product_name: name,
          product_id: id,
          // product_category: 'Shoes',
          // product_variant_id: '1414-Red',
          // product_variant: 'Red',
          product_price: fullPrice,
          product_quantity: 1,
          // product_brand: 'Parker'
        }
      ]
    })


  setupRedditPixel('track', 'Purchase', {
    content_id: id,
    content_name: name,
    value: +fullPrice,
    currency,
  }).then(() => {})

  setupQuoraPixel('track', 'Purchase', {
    content_id: id,
    content_name: name,
    value: +fullPrice,
    currency,
  })

  setupBingPixel('event', 'purchase', {
    revenue_value: +fullPrice,
    // content_id: id,
    // event_category: 'ecommerce',
    // event_label: name,
    currency,
  })
}

export function trackSuccess(transaction_id) {
  // if (window.pintrk) {
  //   window.pintrk('track', 'purchase', {
  //     ...window.pintrkOptions,
  //     event_id: sha256('PurchasePayment_' + window.session_uid),
  //   });
  // }
}
